import PropTypes from 'prop-types';
import React from 'react';

import { ContentCard } from '../content_card/content_card';
import { Text } from '../text/text';

import { SnapshotItem } from './snapshot_item/snapshot_item';
import { InternalLink } from '../internal_link/internal_link';
import { SimpleFlexbox } from '../flexbox/flexbox';

/**
 * Renders the Snapshot
 * @param {Object} props - the set of required props
 * @param {Object} props.contentProps The content properties for this component
 * @param {Object} props.visualProps The visual properties for this component*
 * @returns {ContentCard|null} A ContentCard component or nothing.
 * @constructor
 */
const Snapshot = ({ contentProps, visualProps }) => {
    const { snapshotItems, heading, containerLink } = contentProps;

    /**
     * There can be an optional title containerLink on the right side
     * @returns {Node|Null} A title containerLink
     */
    const getTitleLink = () => {
        return containerLink ? (
            <SimpleFlexbox flex={1}>
                <InternalLink
                    {...contentProps.containerLink.elementProps}
                    {...contentProps.containerLink.contentProps}
                />
            </SimpleFlexbox>
        ) : null;
    };

    const contentCardVisualProps = visualProps.UIComponent ? { UIComponent: visualProps.UIComponent } : {};

    return snapshotItems.length ? (
        <ContentCard visualProps={contentCardVisualProps}>
            <SimpleFlexbox display="flex">
                <SimpleFlexbox flex={8}>
                    <Text size="large_semi_bold" color="brand_base_120">{heading}</Text>
                </SimpleFlexbox>
                {getTitleLink()}
            </SimpleFlexbox>
            {
                snapshotItems.map(({ title, value, link }) => {
                    return (
                        <SnapshotItem
                            key={`Snapshot.${title}.${value}`}
                            visualProps={visualProps}
                            contentProps={{ ...contentProps, title, value, link }}
                        />
                    );
                })
            }
        </ContentCard>
    ) : null;
};

Snapshot.propTypes = {
    contentProps: PropTypes.shape({
        heading: PropTypes.string.isRequired,
        snapshotItems: PropTypes.arrayOf(PropTypes.object).isRequired,
        subHeading: PropTypes.string,
        // If you need a link for the whole container
        containerLink: PropTypes.object
    }),
    visualProps: PropTypes.shape({
        icon: PropTypes.object,
        UIComponent: PropTypes.string,
        variant: PropTypes.string
    })
};

export { Snapshot };
